export default {
	API_KEY: '46233762',
	SESSION_ID: '87f625db5bb3b80135c058390d8140a0a76da938',
	TOKEN: 'T1==cGFydG5lcl9pZD00NjIzMzc2MiZzaWc9NjVlOTBkODRhOTQ1ZmM2MDhjZGYxZjgxOTYwNWU4NDk4YTA4NWQ4ODpzZXNzaW9uX2lkPTJfTVg0ME5qSXpNemMyTW41LU1UVTBORFEwTlRnM05UZ3hOMzVpWnl0T2JYaDNLM2g0TXpKNlVURXpaVmhaTmpaWGVXRi1VSDQmY3JlYXRlX3RpbWU9MTU0NDQ0ODg3OSZub25jZT0wLjI4NDI2NTM3OTAyNDU3ODYmcm9sZT1wdWJsaXNoZXImZXhwaXJlX3RpbWU9MTU0NzA0MDcxMCZpbml0aWFsX2xheW91dF9jbGFzc19saXN0PQ==',
	CHROME_EXTENSION_ID: 'baz'
};
